import moment from 'moment';

// Calming color palette - same as BusDataFormWizard for consistency
export const colors = {
  primary: '#4A90E2',      // Calming blue
  secondary: '#7FB3D5',    // Soft blue
  accent: '#D4E6F1',       // Very light blue
  text: '#2C3E50',         // Dark blue-gray
  background: '#F5F9FC',   // Off-white with blue hint
  success: '#5cb85c',      // Gentle green
  error: '#d9534f',        // Soft red
  warning: '#f0ad4e',      // Warm amber
  white: '#FFFFFF',
  gray: '#ECEFF1'
};

// Format phone number input
export const formatPhoneNumber = (value) => {
  if (!value) return value;
  const phoneNumber = value.replace(/[^\d]/g, '');
  if (phoneNumber.length < 4) return phoneNumber;
  if (phoneNumber.length < 7) {
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
  }
  return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
};

// Calculate if user is a minor based on DOB
export const calculateIsMinor = (dateOfBirth) => {
  if (!dateOfBirth) return false;
  const birthDate = moment(dateOfBirth);
  const today = moment();
  const age = today.diff(birthDate, 'years');
  return age < 18;
};

// US states for dropdown
export const US_STATES = [
  { value: 'AL', label: 'Alabama' },
  { value: 'AK', label: 'Alaska' },
  { value: 'AZ', label: 'Arizona' },
  { value: 'AR', label: 'Arkansas' },
  { value: 'CA', label: 'California' },
  { value: 'CO', label: 'Colorado' },
  { value: 'CT', label: 'Connecticut' },
  { value: 'DE', label: 'Delaware' },
  { value: 'FL', label: 'Florida' },
  { value: 'GA', label: 'Georgia' },
  { value: 'HI', label: 'Hawaii' },
  { value: 'ID', label: 'Idaho' },
  { value: 'IL', label: 'Illinois' },
  { value: 'IN', label: 'Indiana' },
  { value: 'IA', label: 'Iowa' },
  { value: 'KS', label: 'Kansas' },
  { value: 'KY', label: 'Kentucky' },
  { value: 'LA', label: 'Louisiana' },
  { value: 'ME', label: 'Maine' },
  { value: 'MD', label: 'Maryland' },
  { value: 'MA', label: 'Massachusetts' },
  { value: 'MI', label: 'Michigan' },
  { value: 'MN', label: 'Minnesota' },
  { value: 'MS', label: 'Mississippi' },
  { value: 'MO', label: 'Missouri' },
  { value: 'MT', label: 'Montana' },
  { value: 'NE', label: 'Nebraska' },
  { value: 'NV', label: 'Nevada' },
  { value: 'NH', label: 'New Hampshire' },
  { value: 'NJ', label: 'New Jersey' },
  { value: 'NM', label: 'New Mexico' },
  { value: 'NY', label: 'New York' },
  { value: 'NC', label: 'North Carolina' },
  { value: 'ND', label: 'North Dakota' },
  { value: 'OH', label: 'Ohio' },
  { value: 'OK', label: 'Oklahoma' },
  { value: 'OR', label: 'Oregon' },
  { value: 'PA', label: 'Pennsylvania' },
  { value: 'RI', label: 'Rhode Island' },
  { value: 'SC', label: 'South Carolina' },
  { value: 'SD', label: 'South Dakota' },
  { value: 'TN', label: 'Tennessee' },
  { value: 'TX', label: 'Texas' },
  { value: 'UT', label: 'Utah' },
  { value: 'VT', label: 'Vermont' },
  { value: 'VA', label: 'Virginia' },
  { value: 'WA', label: 'Washington' },
  { value: 'WV', label: 'West Virginia' },
  { value: 'WI', label: 'Wisconsin' },
  { value: 'WY', label: 'Wyoming' }
];

// Health conditions for Step 4
export const priorConditionOptions = [
  { value: 'heartAttack', label: 'Heart Attack' },
  { value: 'heartProblems', label: 'Heart Problems' },
  { value: 'stroke', label: 'Stroke' },
  { value: 'highCholesterol', label: 'High Cholesterol' },
  { value: 'badCholesterol', label: 'Bad Cholesterol' },
  { value: 'highBloodPressure', label: 'High Blood Pressure' },
  { value: 'diabetes', label: 'Diabetes' },
  { value: 'cancer', label: 'Cancer' },
  { value: 'liverDisease', label: 'Liver Disease' },
  { value: 'kidneyDisease', label: 'Kidney Disease' },
  { value: 'mentalHealthDisorders', label: 'Mental Health Disorders' },
  { value: 'obesity', label: 'Obesity' },
  { value: 'stress', label: 'Chronic Stress' },
  { value: 'familyHeartDisease', label: 'Family History of Heart Disease' },
  { value: 'earlyHeartDisease', label: 'Early Heart Disease (before age 55 in men, 65 in women)' },
  { value: 'other', label: 'Other' },
  { value: 'none', label: 'None of the above' }
];

export const stepTitles = [
  'Test Selection',
  'Personal Information',
  'Demographics',
  'Health History',
  'Consents',
  'Final Steps'
];
